import { apiRequest } from './client';

export type ReminderInterval = '2bd' | '3bd' | '1w' | '2w' | '1m';
export interface ScanTime {
  hour: number; // 1-12
  minute: number;
  ampm: 'AM' | 'PM';
}
export interface OrgSettings {
  /**
   * Which of the four most recent completed financial years are ticked by default on
   * a new job, as offsets from the newest (0 = newest). Offsets rather than labels so
   * the preference stays correct as the years roll each July.
   */
  financialYearOffsets?: number[];
  engagementTypes: string[];
  docRequirements: string[];
  reminders: ReminderInterval[];
  scanTimes: ScanTime[];
  /** How many times to chase a client for outstanding documents before telling the
   *  owner instead. 0 disables chasing. */
  docChaseMax: number;
  /** Days between chases. */
  docChaseEveryDays: number;
}

export const REMINDER_OPTIONS: { value: ReminderInterval; label: string }[] = [
  { value: '2bd', label: '2 business days' },
  { value: '3bd', label: '3 business days' },
  { value: '1w', label: '1 week' },
  { value: '2w', label: '2 weeks' },
  { value: '1m', label: '1 month' },
];

export function getSettings(): Promise<OrgSettings> {
  return apiRequest<OrgSettings>('/settings');
}
export function putSettings(s: OrgSettings): Promise<OrgSettings> {
  return apiRequest<OrgSettings>('/settings', { method: 'PUT', body: s });
}

export interface XeroStatus {
  connected: boolean;
  tenantName: string | null;
}
export function getXeroStatus(): Promise<XeroStatus> {
  return apiRequest<XeroStatus>('/integrations/xero/status');
}
export function getXeroConnectUrl(): Promise<{ url?: string; authorizeUrl?: string }> {
  return apiRequest('/integrations/xero/connect');
}

export interface Ms365Status {
  connected: boolean;
  mailbox: string | null;
  /** The shared mailbox the app actually sends AS, resolved and verified when the
   *  user connected. This is the address the client sees, not the login. */
  sendAs?: string | null;
  sendAsVerified?: boolean;
  sendAsVerifiedAt?: string | null;
  sendAsError?: string | null;
  /** What the practice has recorded for this person, whether or not they have
   *  connected. Lets Settings name the right account before a wrong sign-in. */
  assignedSendAs?: string | null;
  assignedLogin?: string | null;
}
export function getMs365Status(): Promise<Ms365Status> {
  return apiRequest<Ms365Status>('/integrations/ms365/status');
}
export function getMs365ConnectUrl(): Promise<{ url?: string; authorizeUrl?: string }> {
  return apiRequest('/integrations/ms365/connect');
}
